// ...existing code...
import React from "react";
import "./StaffAugmentation.css";
import {
  FaUserTie,
  FaUsersCog,
  FaLaptopCode,
  FaProjectDiagram,
  FaHandshake,
  FaUserClock,
} from "react-icons/fa";
import { HiOutlineLightBulb } from "react-icons/hi";
import { RiCustomerService2Fill } from "react-icons/ri";
import { Link } from "react-router-dom";

const SERVICES = [
  {
    icon: <FaUsersCog />,
    title: "Dedicated IT Teams",
    text: "Build high-performing development teams tailored to your project needs — fully managed or co-managed.",
  },
  {
    icon: <FaLaptopCode />,
    title: "Software Development Experts",
    text: "Onboard skilled full-stack, backend, or frontend developers for scalable project execution.",
  },
  {
    icon: <FaUserTie />,
    title: "Business Process Specialists",
    text: "Empower ITES operations with experts in data processing, customer support, and analytics.",
  },
  {
    icon: <FaProjectDiagram />,
    title: "Project-Based Augmentation",
    text: "Scale your resources flexibly to meet project deadlines with reliable contract professionals.",
  },
  {
    icon: <FaUserClock />,
    title: "Flexible Engagement Models",
    text: "Hire hourly, part-time, or long-term professionals based on project scope and complexity.",
  },
  {
    icon: <HiOutlineLightBulb />,
    title: "Technology Advisory",
    text: "Consult with experienced IT strategists to plan efficient staffing and resource roadmaps.",
  },
];

const WHY = [
  {
    icon: <FaHandshake />,
    title: "Trusted Global Talent Network",
    text: "Access pre-vetted professionals across 50+ technologies and business domains.",
  },
  {
    icon: <FaUserTie />,
    title: "Agile & Scalable Teams",
    text: "Quick ramp-up and ramp-down flexibility aligned to your delivery timelines.",
  },
  {
    icon: <RiCustomerService2Fill />,
    title: "End-to-End Support",
    text: "From talent onboarding to project delivery — complete workforce lifecycle management.",
  },
];

const StaffAugmentation = () => {
  return (
    <div className="staff-container">
      <header className="staff-header">
        <div className="header-content">
          <h1>STAFF AUGMENTATION – IT & ITES</h1>
          <p className="subtitle">
            Expand your team capacity with skilled professionals in IT and ITES — on-demand, flexible, and cost-effective solutions by Lyros.
          </p>

          <div className="header-ctas">
            <Link
          to="/contact" // ✅ Navigate to Contact page
          className="btn-primary"
          aria-label="Contact Lyros"
        >
          Talk to our Expert team
        </Link>
          </div>
        </div>

        <svg
          className="header-decor"
          viewBox="0 0 800 200"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="gC" x1="0" x2="1">
              <stop offset="0" stopColor="#0ea5e9" stopOpacity="0.14" />
              <stop offset="1" stopColor="#6366f1" stopOpacity="0.06" />
            </linearGradient>
          </defs>
          <path
            d="M0 140 C160 40 360 240 800 80 L800 200 L0 200 Z"
            fill="url(#gC)"
          ></path>
        </svg>
      </header>

      <main className="lyros-main">
        <section className="intro-section card reveal-up">
          <div className="intro-grid">
            <div>
              <h2>Empower your projects with flexible staffing</h2>
              <p>
                Lyros provides agile IT and ITES workforce augmentation that enables you to scale fast,
                reduce costs, and access global talent with domain expertise — without long-term overhead.
              </p>
            </div>

            <div className="kpi-cards">
              <div className="kpi">
                <strong>50%</strong>
                <span>Faster team deployment</span>
              </div>
              <div className="kpi">
                <strong>40%</strong>
                <span>Operational cost savings</span>
              </div>
              <div className="kpi">
                <strong>98%</strong>
                <span>Client satisfaction</span>
              </div>
            </div>
          </div>
        </section>

        <section className="services-section">
          <h3 className="section-title">Our Services</h3>
          <div className="services-grid">
            {SERVICES.map((s, i) => (
              <article className="service-card reveal-up" key={i}>
                <div className="service-icon">{s.icon}</div>
                <div className="service-body">
                  <h4>{s.title}</h4>
                  <p>{s.text}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="examples-section">
          <h3 className="section-title">Our Impact</h3>
          <div className="examples-grid">
            <article className="example-card reveal-up">
              <h4>Enterprise CRM Modernization</h4>
              <p>
                Deployed a blended offshore team to accelerate CRM modernization, improving delivery speed by 45%.
              </p>
            </article>
            <article className="example-card reveal-up">
              <h4>ITES Process Optimization</h4>
              <p>
                Augmented support staff to streamline operations for a BPO client, cutting response time by 35%.
              </p>
            </article>
            <article className="example-card reveal-up">
              <h4>Agile Project Delivery</h4>
              <p>
                Delivered rapid software releases using flexible IT teams, enhancing time-to-market efficiency.
              </p>
            </article>
          </div>
        </section>

        <section className="why-section">
          <h3 className="section-title">Why choose Lyros</h3>
          <div className="why-grid">
            {WHY.map((w, i) => (
              <div className="why-card reveal-up" key={i}>
                <div className="why-icon">{w.icon}</div>
                <div>
                  <h4>{w.title}</h4>
                  <p>{w.text}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="cta-section reveal-up">
          <div className="cta-card">
            <div>
              <h3>Looking to scale your workforce?</h3>
              <p>
                Partner with Lyros for flexible IT & ITES staffing solutions that fit your business goals.
              </p>
            </div>
            <div className="cta-actions">
             <Link
                       to="/contact" // ✅ Navigate to Contact page
                       className="btn-primary"
                       aria-label="Contact Lyros"
                     >
                    Get Started
                     </Link>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default StaffAugmentation;
